import SiteSettings from 'src/siteSetting';
import { APP_LS_NAMESPACE_ID } from 'src/constants';
import {
  SMARTMATCH_TYPE_LOAN_ASSISTANT,
  SMARTMATCH_TYPE_RATE_APPROVER,
} from 'src/services/constants';
import {
  USER_ONBOARD_ADMIN,
  USER_ONBOARD_CDP_OFFICER,
  USER_ONBOARD_CLOSED_LOAN_EDIT_MANAGER,
  USER_ONBOARD_LOAN_OFFICER,
  USER_ONBOARD_LOAN_PROCESSOR,
} from 'src/services/constants/accounts';

export const ADMIN_TABS = [
  {
    title: SiteSettings.pipeLineNameForAllApps(),
    key: 'all_applications',
    order_id: 0,
  },
  {
    title: 'My Applications',
    key: 'my_applications',
    order_id: 1,
  },
  {
    title: 'Pending',
    key: 'pending',
    order_id: 2,
  },
  {
    title: 'Deposit Accounts',
    key: 'deposit_accounts',
    order_id: 3,
  },
  {
    title: 'Approved Not Accepted',
    key: 'approved_not_accepted',
    order_id: 4,
  },
  {
    title: 'Withdrawn',
    key: 'withdrawn',
    order_id: 5,
  },
  {
    title: 'Completed',
    key: 'completed',
    order_id: 6,
  },
  {
    title: 'Declined',
    key: 'declined',
    order_id: 7,
  },
];

const CDP_MANAGER_TABS = [
  {
    title: SiteSettings.pipeLineNameForAllApps(),
    key: 'all_applications',
    order_id: 1,
  },
  {
    title: 'CDP Queue',
    key: 'cdp_queue',
    order_id: 0,
  },
];

export const RELATIONSHIP_MANAGER_TABS = [
  {
    title: 'My Applications',
    key: 'my_applications',
    order_id: 1,
  },
  {
    title: 'My Completed',
    key: 'my_completed',
    order_id: 2,
  },
  {
    title: 'My Declined',
    key: 'my_declined',
    order_id: 3,
  },
];

export const LOAN_EDIT_MANAGER_TABS = [
  {
    title: SiteSettings.pipeLineNameForAllApps(),
    key: 'all_applications',
    order_id: 1,
  },
  {
    title: 'My Applications',
    key: 'my_applications',
    order_id: 2,
  },

  {
    title: 'Completed',
    key: 'completed',
    order_id: 4,
  },
];

export const appPipelineConfig = [
  {
    namespaceId: APP_LS_NAMESPACE_ID,
    role: USER_ONBOARD_LOAN_OFFICER,
    tabs: RELATIONSHIP_MANAGER_TABS,
  },
  {
    namespaceId: APP_LS_NAMESPACE_ID,
    role: USER_ONBOARD_ADMIN,
    tabs: ADMIN_TABS,
  },
  {
    namespaceId: APP_LS_NAMESPACE_ID,
    role: USER_ONBOARD_LOAN_PROCESSOR,
    tabs: ADMIN_TABS,
  },
  {
    namespaceId: APP_LS_NAMESPACE_ID,
    role: USER_ONBOARD_CDP_OFFICER,
    tabs: CDP_MANAGER_TABS,
  },
  {
    namespaceId: APP_LS_NAMESPACE_ID,
    role: USER_ONBOARD_CLOSED_LOAN_EDIT_MANAGER,
    tabs: LOAN_EDIT_MANAGER_TABS,
  },
  {
    namespaceId: APP_LS_NAMESPACE_ID,
    role: SMARTMATCH_TYPE_RATE_APPROVER,
    tabs: RELATIONSHIP_MANAGER_TABS,
  },
  {
    namespaceId: APP_LS_NAMESPACE_ID,
    role: SMARTMATCH_TYPE_LOAN_ASSISTANT,
    tabs: RELATIONSHIP_MANAGER_TABS,
  },
];
